 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"app-catalog~dashboard~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"app-catalog~dashboard~forms~marketing~modern-trade~notification~pages~pos~seller~tables","app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables":"app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables","app-catalog~dashboard~marketing~modern-trade~pages~pos~tables":"app-catalog~dashboard~marketing~modern-trade~pages~pos~tables","dashboard~extra":"dashboard~extra","dashboard":"dashboard","app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables","app-catalog":"app-catalog","marketing":"marketing","modern-trade":"modern-trade","pages":"pages","pos":"pos","tables":"tables","notification":"notification","seller":"seller","forms":"forms","components":"components","extra":"extra"}[chunkId]||chunkId) + "." + {"app-catalog~dashboard~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"c552c790","app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables":"f7cf14eb","app-catalog~dashboard~marketing~modern-trade~pages~pos~tables":"6e82f478","dashboard~extra":"28d8db72","dashboard":"94b9d8fd","app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"201cce1a","app-catalog":"592aa2f5","marketing":"68618ab4","modern-trade":"db3eca18","pages":"755e5247","pos":"a5ad5463","tables":"b1b52832","notification":"44398b64","seller":"3f6715e9","forms":"12ca70b2","chunk-73104981":"a5f0d727","components":"5987a152","extra":"08467008","chunk-490e6dd7":"35fd61f7","chunk-55c015f8":"71e6b863","chunk-681b6bad":"48a4eeec"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables":1,"app-catalog~dashboard~marketing~modern-trade~pages~pos~tables":1,"dashboard~extra":1,"dashboard":1,"app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables":1,"app-catalog":1,"marketing":1,"modern-trade":1,"pages":1,"pos":1,"tables":1,"seller":1,"forms":1,"components":1,"extra":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"app-catalog~dashboard~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"app-catalog~dashboard~forms~marketing~modern-trade~notification~pages~pos~seller~tables","app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables":"app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables","app-catalog~dashboard~marketing~modern-trade~pages~pos~tables":"app-catalog~dashboard~marketing~modern-trade~pages~pos~tables","dashboard~extra":"dashboard~extra","dashboard":"dashboard","app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables","app-catalog":"app-catalog","marketing":"marketing","modern-trade":"modern-trade","pages":"pages","pos":"pos","tables":"tables","notification":"notification","seller":"seller","forms":"forms","components":"components","extra":"extra"}[chunkId]||chunkId) + "." + {"app-catalog~dashboard~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"31d6cfe0","app-catalog~dashboard~marketing~modern-trade~notification~pages~pos~seller~tables":"91927107","app-catalog~dashboard~marketing~modern-trade~pages~pos~tables":"aa7fe452","dashboard~extra":"443d7ae7","dashboard":"5caf6deb","app-catalog~forms~marketing~modern-trade~notification~pages~pos~seller~tables":"847108d3","app-catalog":"25a17ad7","marketing":"8e7a1fdf","modern-trade":"709db840","pages":"37dfaaeb","pos":"73c61e9c","tables":"e206a854","notification":"31d6cfe0","seller":"91c871b9","forms":"79c177b7","chunk-73104981":"31d6cfe0","components":"5bf948a7","extra":"80f8870a","chunk-490e6dd7":"31d6cfe0","chunk-55c015f8":"31d6cfe0","chunk-681b6bad":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
